import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * id (name) of the radio group
   */
  id: PropTypes.string.isRequired,
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * options of the radio group
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string, // option value needs to be an string!
    }),
  ).isRequired,
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Selected value
   */
  value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  /**
   * validation errors messages
   */
  errors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Class to style the title
   */
  titleClassName: PropTypes.string,
  /**
   * Indicates if field is required
   */
  required: PropTypes.bool,
}

function RadioGroup(props) {
  const {
    id,
    title = null,
    options,
    onChange,
    value = null,
    errors = [],
    titleClassName = '',
    required = false,
    ...rest
  } = props ?? {}

  return (
    <div className="mb-3">
      {title && (
        <p className={clsx('mb-2', titleClassName)}>
          <FormattedMessage id={title} />
          {required && <span className="font-size-regular text-color-danger">*</span>}
        </p>
      )}

      {options.map((option) => (
        <Form.Check
          key={option.value}
          {...rest}
          custom
          type="radio"
          name={id} // in a radio group all radios should have the same name
          id={option.value} // options values are mapped as the radio id and radio value
          value={option.value}
          checked={option.value === value}
          label={option.label}
          onChange={(event) => onChange(event.target.value)}
        />
      ))}

      {errors?.map((errorMessage) => (
        <div key={errorMessage} className="text-color-danger mt-2">
          {errorMessage}
        </div>
      ))}
    </div>
  )
}

RadioGroup.propTypes = propTypes

export default RadioGroup
